//set the geoJSON style
import { ReinosMaps } from '../core'
import { reverseLatLngArray } from '../utils'

ReinosMaps.prototype.reverseLatLngArray = function (array) {
  return reverseLatLngArray(array)
}
